import { useEffect, useRef } from 'react'

export interface Options {
  restoreOnUnmount?: boolean
}

const DEFAULT_OPTIONS: Options = {
  restoreOnUnmount: false,
}

export default function useTitle(title: string, options: Options = DEFAULT_OPTIONS) {
  const titleRef = useRef(document.title)
  useEffect(() => {
    titleRef.current = document.title
    document.title = title

    return () => {
      if (options && options.restoreOnUnmount) {
        document.title = titleRef.current
      }
    }
  }, [title])
}
